/* Raghu  27/10/2022 3075154998 Input Field Enhancements */
/* Rohini  28/10/2022 3075154998 text field enhancements
Suresh Peddavoora 11/03/2022 3075154998 Text fields Tab Responsive Fixes

*/
import React, {useEffect, useState, useContext} from 'react';
import {Form, Formik} from 'formik';
import {Button, Grid, TextField} from '@material-ui/core';
import ErrorBoundaryForComponents from '../../../../../util/ErrorBoundaryForComponents';
import EnableFileFormatSearchTable from './EnableFileFormatSearchTable';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import {ResetStatus as resetMediaType} from '../../../../../redux/reducers/EnableFramework/AddMediaType';
import {ResetStatus as resetFilterGroup} from '../../../../../redux/reducers/EnableFramework/FilterGroup';
import {useDispatch, useSelector} from 'react-redux';
import {
  resetToast as resetMapData,
  resetToast,
} from '../../../../../redux/reducers/EnableFramework/AddEnableFileFormat';
import DialogBox from '../../../../../components/DialogBox';
import RunaReportEnable from './RunaReport';
import {ErrorSnackbar, SuccessSnackbar} from '../../../../../components/CustomSnackBar';
const SearchEnableFormatContainer = ({setTabValue, setEnableCode, setResetData}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const [searchData, setSearchData] = useState([]);
  const [jobCode, setJobCode] = useState('');

  const [open, setOpen] = useState(false);
  const {successMsg, addEnableFileFormatStatus, errorMsg} = useSelector(
    ({addEnableFileFormat}) => addEnableFileFormat,
  );
  const [submit, setSubmit] = useState(false);
  const handleSubmit = (data) => {
    setSearchData(data);
    setSubmit(true);
  };

  const initialValues = {
    fileFormat: '',
    description: '',
  };

  useEffect(() => {
    dispatch(resetMediaType());
    dispatch(resetFilterGroup());
    dispatch(resetMapData());
  }, []);

  const onClear = () => {
    const data = {
      fileFormat: '',
      description: '',
    };
    setSearchData(data);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (addEnableFileFormatStatus === 200) {
      handleClose();
      setTimeout(() => {
        resetToast();
      }, 2000);
    }
  }, [addEnableFileFormatStatus]);

  return (
    <>
      <div>
        <Formik
          onSubmit={(values) => handleSubmit(values)}
          initialValues={initialValues}
          enableReinitialize
        >
          {(props) => {
            const {values, handleChange, handleBlur, handleReset} = props;
            return (
              <div className={classes.ruleGroupCard}>
                <Form autoComplete="off" noValidate>
                  <div>
                    <ErrorBoundaryForComponents>
                      <Grid className="form-row global-field-textfields" container spacing={2}>
                        <Grid item sm={6} md={4} xl={3} className="form-group">
                          <TextField
                            className={` ${classes.labelName} ${classes.inputLabel}`}
                            margin="dense"
                            variant="standard"
                            placeholder={`Enter File Format`}
                            label="File Format"
                            name="fileFormat"
                            value={values.fileFormat}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            fullWidth
                          />
                        </Grid>
                        <Grid item xs={4} sm={6} md={5} xl={6} className="form-group">
                          <TextField
                            className={` ${classes.labelName} ${classes.inputLabel}`}
                            margin="dense"
                            variant="standard"
                            name="description"
                            placeholder={`Enter Description`}
                            label="Description"
                            value={values.description}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            fullWidth
                          />
                        </Grid>

                        <Grid item xs={4} sm={6} md={3} xl={3} className="form-group">
                          <div className="d-flex justify-content-end align-items-center">
                            <Button
                              variant="outlined"
                              className={`mx-1 reset-btn ${classes.buttonRoot}`}
                              onClick={() => {
                                handleReset();
                                setSearchData({});
                                setSubmit(true);
                                onClear();
                              }}
                            >
                              Clear
                            </Button>
                            <Button
                              variant="outlined"
                              type="submit"
                              className={`search-btn mx-1 ${classes.buttonRoot}`}
                            >
                              Search
                            </Button>
                          </div>
                        </Grid>
                      </Grid>
                    </ErrorBoundaryForComponents>
                  </div>
                </Form>
              </div>
            );
          }}
        </Formik>
        <EnableFileFormatSearchTable
          setTabValue={setTabValue}
          searchData={searchData}
          setSearchData={setSearchData}
          setEnableCode={setEnableCode}
          submit={submit}
          setSubmit={setSubmit}
          setResetData={setResetData}
          setOpen={setOpen}
          setJobCode={setJobCode}
        />
      </div>
      <DialogBox open={open} dialogClose={handleClose} title="Run Enable" maxWidth="md">
        <RunaReportEnable jobCode={jobCode} handleClose={handleClose} />
      </DialogBox>
      {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
      {successMsg && <SuccessSnackbar successMsg={successMsg} />}
    </>
  );
};
export default SearchEnableFormatContainer;
